/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/signup-overlay */
import baustein from "baustein";
import analytics from "analytics/analytics";
import logging from "../../utils/logging";
import history from "../../utils/history";
import overlayMixin from "components/mixins/overlay-mixin";
import requester from "modules/requester";
import { fromString } from "dom/factory";
import globals from "../../modules/globals";

import SignupOverlay from "components/overlays/signup-overlay";

/**
 * Handles functionality of the sign up overlay
 *
 * @constructor
 * @alias module:components/signup-overlay
 * @extends module:baustein
 */
export default baustein.register(
    "login-overlay",
    /** @lends module:components/signup-overlay.prototype */
    {
        mixins: [overlayMixin],

        defaultOptions: {
            overlaySize: "small",
            noContentPadding: true,
            queryParams: {},
            path: "/account/login/",
            formType: "unknown",
            loginSuccessRedirectUrl: window.location.pathname + window.location.search
        },

        setupEvents: function(add) {
            add("click", "input", this.onFormClick);
            add("form-submit-success", "ajax-form", this.onSubmitSuccess);
            add("click", ".login-overlay__signup-link", this.switchToSignup);
        },

        onOverlayCloseIntent() {
            history.back();
            this.close();
        },

        onOverlayOpen() {
            this.trackPageView();
        },

        onInsert() {
            this.onOptionsChange();
        },

        trackPageView() {
            analytics.pageView();
        },

        /**
         * Handler for the form
         * @param {object} event
         */
        onSubmitSuccess(event) {
            var response = event.formData;
            if (response.success) {
                // set a param so save-for-later callout is shown on page reload
                if (this.options.formType === "save_for_later_sign_in") {
                    analytics.event("SIGN_IN", "SIGN_IN_LYST", "save_for_later");
                } else if (this.options.formType === "sign_in") {
                    analytics.event("SIGN_IN", "SIGN_IN_LYST", "signin");
                }
                if (response.data && response.data["redirect_url"]) {
                    globals.window.location = response.data["redirect_url"];
                } else {
                    globals.window.location = this.options.loginSuccessRedirectUrl;
                }
            } else {
                switch (response.error) {
                    case "SIGNUP_FORM_ERROR":
                        this.handleSignupErrors(response.data.errors);
                        break;
                    case "LOGIN_FORM_ERROR":
                        this.handleLoginErrors(response.data.errors);
                        break;
                    default:
                        logging.error("Unknown error trying to capture email address.");
                }
            }
        },

        switchToSignup(event) {
            event.preventDefault();
            this.close();
            const overlay = new SignupOverlay({
                isOverlay: true,
                queryParams: this.options.queryParams
            });
            overlay.appendTo(document.body);
            overlay.open();
        },

        getOverlayContent() {
            const queryParams = this.options.queryParams;
            const redirectUrl = this.options.loginSuccessRedirectUrl;
            return requester(this.options.path, {
                headers: {
                    Accept: "text/html"
                },
                query: queryParams
            }).then(function(resp) {
                // If we get back application/json then the user is
                // already logged in. Perhaps a further improvement -
                // we detect this when the save for later button is
                // clicked and redirect + save for later at the same
                // time
                if (
                    resp.status === 200 &&
                    resp.headers.get("content-type") === "application/json"
                ) {
                    globals.window.location = redirectUrl;
                    return;
                } else {
                    return requester.toText(resp);
                }
            });
        },

        onOptionsChange() {
            this.el.scrollTop = 0;
            const queryParams = history.getCurrentQueryParams();
            history.replaceState(this.options.path, queryParams);
            this.getOverlayContent()
                .then(this.setContent.bind(this))
                .then(this.trackPageView.bind(this));
        },

        onFormClick: function(event, element) {
            let name = element.name;
            analytics.event("SIGN_IN", "INPUT_CLICK", "input_" + name);
        },

        clearErrors() {
            Array.from(this.el.querySelectorAll(".form-item-error")).forEach(element => {
                element.parentElement.removeChild(element);
            });
        },

        showError(errorMessage, errorSelector) {
            const item = this.el.querySelector(errorSelector);
            if (item) {
                item.appendChild(
                    fromString(`
                    <div class="form-item-error">${errorMessage}</div>
                `)
                );
            }
        },

        handleLoginErrors(errors) {
            this.clearErrors();
            if ("password" in errors) {
                this.showError(errors["password"].join(" "), ".form-item-password");
            }
            if ("username" in errors) {
                this.showError(errors["username"].join(" "), ".form-item-username");
            }
            // capture generic errors
            if ("__all__" in errors) {
                this.showError(errors["__all__"].join(" "), ".form-item-generic");
            }
        },

        _isSaveForLaterOverlay() {
            return this.options.formType.includes("save_for_later");
        }
    }
);

